/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthCreationLinkedPreAuth } from './PalReauthCreationLinkedPreAuth';
import {
    PalReauthCreationLinkedPreAuthFromJSON,
    PalReauthCreationLinkedPreAuthFromJSONTyped,
    PalReauthCreationLinkedPreAuthToJSON,
    PalReauthCreationLinkedPreAuthToJSONTyped,
} from './PalReauthCreationLinkedPreAuth';
import type { PalReauthCreationInsurance } from './PalReauthCreationInsurance';
import {
    PalReauthCreationInsuranceFromJSON,
    PalReauthCreationInsuranceFromJSONTyped,
    PalReauthCreationInsuranceToJSON,
    PalReauthCreationInsuranceToJSONTyped,
} from './PalReauthCreationInsurance';

/**
 * 
 * @export
 * @interface PalReauthCreationContext
 */
export interface PalReauthCreationContext {
    /**
     * 
     */
    insurances: Array<PalReauthCreationInsurance>;
    /**
     * The lead's latest pre-auth, in any status. A new re-auth is linked to it.
     */
    latest_pal_submission: PalReauthCreationLinkedPreAuth | null;
    /**
     * 
     */
    original_move_in_date: string | null;
    /**
     * 
     */
    max_cycle_number: number | null;
    /**
     * 
     */
    has_active_non_final_reauth: boolean;
    /**
     * Today's date (YYYY-MM-DD) in the facility's time zone. The next review date can't be before it.
     */
    facility_today: string;
}

/**
 * Check if a given object implements the PalReauthCreationContext interface.
 */
export function instanceOfPalReauthCreationContext(value: object): value is PalReauthCreationContext {
    if (!('insurances' in value) || value['insurances'] === undefined) return false;
    if (!('latest_pal_submission' in value) || value['latest_pal_submission'] === undefined) return false;
    if (!('original_move_in_date' in value) || value['original_move_in_date'] === undefined) return false;
    if (!('max_cycle_number' in value) || value['max_cycle_number'] === undefined) return false;
    if (!('has_active_non_final_reauth' in value) || value['has_active_non_final_reauth'] === undefined) return false;
    if (!('facility_today' in value) || value['facility_today'] === undefined) return false;
    return true;
}

export function PalReauthCreationContextFromJSON(json: any): PalReauthCreationContext {
    return PalReauthCreationContextFromJSONTyped(json, false);
}

export function PalReauthCreationContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthCreationContext {
    if (json == null) {
        return json;
    }
    return {
        
        'insurances': ((json['insurances'] as Array<any>).map(PalReauthCreationInsuranceFromJSON)),
        'latest_pal_submission': PalReauthCreationLinkedPreAuthFromJSON(json['latest_pal_submission']),
        'original_move_in_date': json['original_move_in_date'],
        'max_cycle_number': json['max_cycle_number'],
        'has_active_non_final_reauth': json['has_active_non_final_reauth'],
        'facility_today': json['facility_today'],
    };
}

export function PalReauthCreationContextToJSON(json: any): PalReauthCreationContext {
    return PalReauthCreationContextToJSONTyped(json, false);
}

export function PalReauthCreationContextToJSONTyped(value?: PalReauthCreationContext | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'insurances': ((value['insurances'] as Array<any>).map(PalReauthCreationInsuranceToJSON)),
        'latest_pal_submission': PalReauthCreationLinkedPreAuthToJSON(value['latest_pal_submission']),
        'original_move_in_date': value['original_move_in_date'],
        'max_cycle_number': value['max_cycle_number'],
        'has_active_non_final_reauth': value['has_active_non_final_reauth'],
        'facility_today': value['facility_today'],
    };
}

